import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "SignalCardTextDv" }
const _hoisted_2 = { class: "headingInfoHeadDv" }
const _hoisted_3 = { class: "caption-text" }
const _hoisted_4 = { class: "caption-text" }
const _hoisted_5 = { class: "caption-text" }
const _hoisted_6 = { class: "signalHeader" }
const _hoisted_7 = { class: "firstDv" }
const _hoisted_8 = { class: "textDv" }
const _hoisted_9 = { class: "endDv" }
const _hoisted_10 = { class: "lastDv" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "signalMiddle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_StockImageTag = _resolveComponent("StockImageTag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_SparklineComponent = _resolveComponent("SparklineComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.addPostModelDv.position === 'buy')
          ? (_openBlock(), _createElementBlock("h3", {
              key: 0,
              class: _normalizeClass({
          buy: _ctx.addPostModelDv.position === 'buy',
          sell: _ctx.addPostModelDv.position === 'sell',
          neutral: _ctx.addPostModelDv.position === 'neutral',
        })
            }, [
              _createVNode(_component_IconComponent, {
                class: "priceIcon",
                icon: "stock-pricing-up-icon.svg"
              }),
              _cache[0] || (_cache[0] = _createTextVNode(" BULLISH ", -1)),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.addPostModelDv.title), 1)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.addPostModelDv.position === 'sell')
          ? (_openBlock(), _createElementBlock("h3", {
              key: 1,
              class: _normalizeClass({
          buy: _ctx.addPostModelDv.position === 'buy',
          sell: _ctx.addPostModelDv.position === 'sell',
          neutral: _ctx.addPostModelDv.position === 'neutral',
        })
            }, [
              _createVNode(_component_IconComponent, {
                class: "priceIcon",
                icon: "stock-pricing-up-icon.svg"
              }),
              _cache[1] || (_cache[1] = _createTextVNode(" BEARISH ", -1)),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.addPostModelDv.title), 1)
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.addPostModelDv.position === 'neutral')
          ? (_openBlock(), _createElementBlock("h3", {
              key: 2,
              class: _normalizeClass({
          buy: _ctx.addPostModelDv.position === 'buy',
          sell: _ctx.addPostModelDv.position === 'sell',
          neutral: _ctx.addPostModelDv.position === 'neutral',
        })
            }, [
              _cache[2] || (_cache[2] = _createTextVNode(" NEUTRAL ", -1)),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.addPostModelDv.title), 1)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("p", null, _toDisplayString(_ctx.addPostModelDv.description), 1)
    ]),
    (_ctx.addPostModelDv && _ctx.addPostModelDv.title && _ctx.stock)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["signalCardsDv", { fromPopup: _ctx.fromPopup }])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_StockImageTag, {
                stockId: _ctx.stock.stockId,
                imgUrl: _ctx.stock.logoUrl,
                symbol: _ctx.stock.symbol,
                market: _ctx.stock?.type
              }, null, 8, ["stockId", "imgUrl", "symbol", "market"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.stock.symbol ?? "-"), 1),
                _createVNode(_component_el_tooltip, {
                  class: "box-item",
                  effect: "dark",
                  content: _ctx.stock.name ?? '-',
                  placement: "top-start"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(_ctx.stock.name ?? "-"), 1)
                  ]),
                  _: 1
                }, 8, ["content"])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h2", {
                  class: "whiteDoler",
                  ref: "priceElement",
                  innerHTML: 
              _ctx.$filters.systemNumberConvention(
                _ctx.stock.price,
                true,
                false,
                _ctx.widthCalculating
              )
            
                }, null, 8, _hoisted_11),
                _createElementVNode("div", {
                  class: _normalizeClass([{
              downward: _ctx.stock.changesPercentage < 0,
            }, "informationGridWatchlistViewDv"])
                }, [
                  _createVNode(_component_el_tooltip, {
                    class: "box-item",
                    effect: "dark",
                    content: '$' + _ctx.stock.change,
                    placement: "top-start"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_IconComponent, {
                          class: "priceIcon",
                          icon: "stock-pricing-up-icon.svg"
                        }),
                        _createTextVNode(" " + _toDisplayString(Math.abs(
                    _ctx.$filters.systemNumberConvention(
                      _ctx.stock.changesPercentage,
                      false
                    )
                  )) + "% ", 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["content"])
                ], 2)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.showChart)
              ? (_openBlock(), _createBlock(_component_SparklineComponent, {
                  key: 0,
                  isPositive: _ctx.stock?.changesPercentage >= 0,
                  data: _ctx.stock?.fiveDayTrend?.[0].data
                }, null, 8, ["isPositive", "data"]))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}